/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UnistackOauthAuthorizeRsp } from '../models/unistack-oauth-authorize-rsp';
import { UnistackOauthListRsp } from '../models/unistack-oauth-list-rsp';
import { UnistackOauthRevokeRsp } from '../models/unistack-oauth-revoke-rsp';
import { UnistackOauthRevokeReq } from '../models/unistack-oauth-revoke-req';
import { UnistackOauthToken } from '../models/unistack-oauth-token';
import { UnistackOauthTokenRsp } from '../models/unistack-oauth-token-rsp';
import { UnistackOauthTokenReq } from '../models/unistack-oauth-token-req';
@Injectable({
  providedIn: 'root',
})
class OauthServiceService extends __BaseService {
  static readonly OauthAuthPath = '/api/unistack/v0/oauth/auth';
  static readonly OauthListPath = '/api/unistack/v0/oauth/list';
  static readonly OauthRevokePath = '/api/unistack/v0/oauth/revoke';
  static readonly OauthLookupPath = '/api/unistack/v0/oauth/token';
  static readonly OauthTokenPath = '/api/unistack/v0/oauth/token';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `OauthServiceService.OauthAuthParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `scope`:
   *
   * - `response_type`:
   *
   * - `redirect_uri`:
   *
   * - `extra`:
   *
   * - `expires_in`:
   *
   * - `created`:
   *
   * - `code`:
   *
   * - `client_id`:
   *
   * @return A successful response.
   */
  OauthAuthResponse(params: OauthServiceService.OauthAuthParams): __Observable<__StrictHttpResponse<UnistackOauthAuthorizeRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.state != null) __params = __params.set('state', params.state.toString());
    if (params.scope != null) __params = __params.set('scope', params.scope.toString());
    if (params.responseType != null) __params = __params.set('response_type', params.responseType.toString());
    if (params.redirectUri != null) __params = __params.set('redirect_uri', params.redirectUri.toString());
    if (params.extra != null) __params = __params.set('extra', params.extra.toString());
    if (params.expiresIn != null) __params = __params.set('expires_in', params.expiresIn.toString());
    if (params.created != null) __params = __params.set('created', params.created.toString());
    if (params.code != null) __params = __params.set('code', params.code.toString());
    if (params.clientId != null) __params = __params.set('client_id', params.clientId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/oauth/auth`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackOauthAuthorizeRsp>;
      })
    );
  }
  /**
   * @param params The `OauthServiceService.OauthAuthParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `scope`:
   *
   * - `response_type`:
   *
   * - `redirect_uri`:
   *
   * - `extra`:
   *
   * - `expires_in`:
   *
   * - `created`:
   *
   * - `code`:
   *
   * - `client_id`:
   *
   * @return A successful response.
   */
  OauthAuth(params: OauthServiceService.OauthAuthParams): __Observable<UnistackOauthAuthorizeRsp> {
    return this.OauthAuthResponse(params).pipe(
      __map(_r => _r.body as UnistackOauthAuthorizeRsp)
    );
  }

  /**
   * @return A successful response.
   */
  OauthListResponse(): __Observable<__StrictHttpResponse<UnistackOauthListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/oauth/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackOauthListRsp>;
      })
    );
  }
  /**
   * @return A successful response.
   */
  OauthList(): __Observable<UnistackOauthListRsp> {
    return this.OauthListResponse().pipe(
      __map(_r => _r.body as UnistackOauthListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  OauthRevokeResponse(body: UnistackOauthRevokeReq): __Observable<__StrictHttpResponse<UnistackOauthRevokeRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/oauth/revoke`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackOauthRevokeRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  OauthRevoke(body: UnistackOauthRevokeReq): __Observable<UnistackOauthRevokeRsp> {
    return this.OauthRevokeResponse(body).pipe(
      __map(_r => _r.body as UnistackOauthRevokeRsp)
    );
  }

  /**
   * @param params The `OauthServiceService.OauthLookupParams` containing the following parameters:
   *
   * - `refresh`:
   *
   * - `account`:
   *
   * - `access`:
   *
   * @return A successful response.
   */
  OauthLookupResponse(params: OauthServiceService.OauthLookupParams): __Observable<__StrictHttpResponse<UnistackOauthToken>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.refresh != null) __params = __params.set('refresh', params.refresh.toString());
    if (params.account != null) __params = __params.set('account', params.account.toString());
    if (params.access != null) __params = __params.set('access', params.access.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/oauth/token`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackOauthToken>;
      })
    );
  }
  /**
   * @param params The `OauthServiceService.OauthLookupParams` containing the following parameters:
   *
   * - `refresh`:
   *
   * - `account`:
   *
   * - `access`:
   *
   * @return A successful response.
   */
  OauthLookup(params: OauthServiceService.OauthLookupParams): __Observable<UnistackOauthToken> {
    return this.OauthLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackOauthToken)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  OauthTokenResponse(body: UnistackOauthTokenReq): __Observable<__StrictHttpResponse<UnistackOauthTokenRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/oauth/token`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackOauthTokenRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  OauthToken(body: UnistackOauthTokenReq): __Observable<UnistackOauthTokenRsp> {
    return this.OauthTokenResponse(body).pipe(
      __map(_r => _r.body as UnistackOauthTokenRsp)
    );
  }
}

module OauthServiceService {

  /**
   * Parameters for OauthAuth
   */
  export interface OauthAuthParams {
    state?: string;
    scope?: string;
    responseType?: string;
    redirectUri?: string;
    extra?: string;
    expiresIn?: string;
    created?: string;
    code?: string;
    clientId?: string;
  }

  /**
   * Parameters for OauthLookup
   */
  export interface OauthLookupParams {
    refresh?: string;
    account?: string;
    access?: string;
  }
}

export { OauthServiceService }
